import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slice/authSlice";
import jobReducer from "./slice/jobSlice";
import userReducer from "./slice/userSlice";
import toolReducer from "./slice/toolSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    job: jobReducer,
    user: userReducer,
    tool: toolReducer,
  },
});

export const RootState = {
  auth: { user: null, loading: false, error: null },
  job: { jobs: [], loading: false, error: null },
  user: { users: [], loading: false, error: null },
  tool: { tools: [], loading: false, error: null },
};
